module.exports = __webpack_public_path__ + "static/media/bkg-wall-e-03.4ddc01f5.jpg";